var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 22.3984V10.0703C24 9.36719 23.625 8.71094 23.1094 8.28906C21.9375 7.39844 21 6.64844 15.4219 2.61719C14.625 2.05469 13.0781 0.648438 12 0.695312C10.875 0.648438 9.32812 2.05469 8.53125 2.61719C2.95312 6.64844 2.01562 7.39844 0.84375 8.28906C0.328125 8.71094 0 9.36719 0 10.0703V22.3984C0 23.6641 0.984375 24.6484 2.25 24.6484H21.75C22.9688 24.6484 24 23.6641 24 22.3984ZM20.9062 13.2109L21.3281 13.8203C21.375 13.8672 21.375 13.9609 21.375 14.0547C21.375 14.1484 21.3281 14.2891 21.2344 14.3359C20.1562 15.1328 18.6562 16.2578 16.3125 17.9453C15.3281 18.6484 13.6406 20.1953 12 20.1484C10.3125 20.1953 8.625 18.6484 7.64062 17.9453C5.29688 16.2578 3.79688 15.1328 2.71875 14.3359C2.625 14.2891 2.57812 14.1484 2.57812 14.0547C2.57812 13.9609 2.57812 13.8672 2.625 13.8203L3.04688 13.2109C3.1875 13.0234 3.42188 12.9766 3.60938 13.1172C4.64062 13.9141 6.1875 15.0391 8.53125 16.7266C9.32812 17.2891 10.875 18.6953 12 18.6484C13.0781 18.6953 14.625 17.2891 15.4219 16.7266C17.7656 15.0391 19.3125 13.9141 20.3438 13.1172C20.5312 12.9766 20.7656 13.0234 20.9062 13.2109Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.5ffd34736b3c2633cdb21cb1f96721f1.svg";
export { ForwardRef as ReactComponent };